module.exports = __webpack_public_path__ + "static/testimonial_unrotated-bace36a7d79ac79d6900b87358459d1b.png";